import { Box, Button } from '@mui/material';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';

interface SubscriptionFooterProps {
  onManageBilling: () => void;
  onCancel: () => void;
  managingBilling?: boolean;
}

export const SubscriptionFooter: React.FC<SubscriptionFooterProps> = ({
  onManageBilling,
  onCancel,
  managingBilling = false,
}) => (
  <Box
    sx={{
      p: 2.25,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: 1.5,
    }}
  >
    <Button
      variant="outlined"
      startIcon={<ReceiptLongOutlinedIcon />}
      onClick={onManageBilling}
      disabled={managingBilling}
    >
      Manage Payment & Invoices
    </Button>
    <Button color="error" onClick={onCancel}>
      Cancel Subscription
    </Button>
  </Box>
);
